export default __webpack_public_path__ + "static/media/warning-icon.e984bba1.svg";